import { windowWidth } from "./utils";
const descMenu = {
  links: document.querySelectorAll(".jsDescMenuLink") as NodeListOf<HTMLElement>,
  subMenus: document.querySelectorAll(".jsDescSubMenu") as NodeListOf<HTMLElement>,
  header: document.getElementById("header") as HTMLElement,
  deskOverlay: document.getElementById("deskOverlay") as HTMLElement,
  headerWrap: document.getElementById('jsHeaderMain'),
  closeMenu: document.querySelectorAll(".jsCloseMenu") as NodeListOf<HTMLElement>,
  shopBtn: document.getElementById('jsOpenCats') as HTMLElement,
  deskNav: document.getElementById('jsDeskNav') as HTMLElement,
  brandBtn: document.getElementById('jsOpenBrands') as HTMLElement,
  brandNav: document.getElementById('jsBrandsNav') as HTMLElement,
  firstLink: document.querySelector('.first-item-selected') as HTMLElement,
  init() {
    if (windowWidth  > 1200) {
      this.toggleMenu()
      this.overlayClick()
      this.setCloseAll()
      this.setShopAll()
      this.setBrands()
      this.setCLoseMenu()
    }  
  },


  setShopAll() {
      this.shopBtn.addEventListener('click', () => {
      this.deskNav.classList.add('activeClass');
      this.deskOverlay.classList.add("activeClass")
      this.shopBtn.classList.add('activeClass')            
      this.brandNav.classList.remove('activeClass');
      this.brandBtn.classList.remove('activeClass');
      this.firstLink.classList.add('activeClass');    
    
    })
  },

  setBrands(){
        this.brandBtn.addEventListener('click', () => {
        this.brandNav.classList.add('activeClass');
        this.deskOverlay.classList.add("activeClass")
        this.brandBtn.classList.add('activeClass')
        this.deskNav.classList.remove('activeClass');
         this.shopBtn.classList.remove('activeClass');
    })
  },


  toggleMenu() {
    this.links.forEach((item, index) => {
      item.addEventListener("mouseenter", (e) => {
        this.resetClasses()
        e.preventDefault()
        this.header.classList.add("activeClass")
        this.deskOverlay.classList.add("activeClass")
        item.classList.add("activeClass")
        this.headerWrap?.classList.add('activeClass')
        this.subMenus[index].classList.remove("d-none");
      })
    })
  },
  resetClasses() {
    this.links.forEach((item) => item.classList.remove("activeClass"))
    this.subMenus.forEach((item) => item.classList.add("d-none"))
    this.header.classList.remove("activeClass")
    this.deskOverlay.classList.remove("activeClass")
    this.headerWrap?.classList.remove('activeClass')
  },
  setCloseAll(){
    this.closeMenu.forEach(item=>{
      item.addEventListener('click', ()=>{
        this.resetClasses()
        this.deskNav.classList.remove('activeClass');
        this.shopBtn.classList.remove('activeClass');
        this.brandNav.classList.remove('activeClass');
        this.brandBtn.classList.remove('activeClass');
      })
    })
  },


  setCLoseMenu() {
    window.addEventListener('click', (e) => {
      const target = e.target as HTMLElement; 

      if(target !== this.deskNav && !this.deskNav.contains(target) && target !== this.shopBtn && !this.shopBtn.contains(target) && target !== this.brandNav && !this.brandNav.contains(target) && target !== this.brandBtn && !this.brandBtn.contains(target)) {
         this.resetClasses()
        this.deskNav.classList.remove('activeClass');
        this.brandNav.classList.remove('activeClass');
        this.shopBtn.classList.remove('activeClass');
        this.brandBtn.classList.remove('activeClass');
      }
    })
  },

  overlayClick(){
    this.deskOverlay.addEventListener("click", (e) => {
        this.resetClasses()
    })
  }
}

export default descMenu